// Path in repo: src/pages/organization-dashboard/components/analytics/LearnerMix.jsx
//
// Learner mix by engagement stage — pairs with "Audiences → Segments" nav.

import React from "react"
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../../../components/ui/card"
import {
  ShareBarList, ShareBarListContent, ShareBarListFill,
  ShareBarListItem, ShareBarListLabel, ShareBarListValue,
} from "../../../../components/share-bar-list"

const FALLBACK_ROWS = [
  { label: "Actively enrolled", share: 47 },
  { label: "Completed a course", share: 34 },
  { label: "Inactive 30+ days", share: 19 },
]

const LearnerMix = ({ rows, title = "Learner mix", description = "Engagement stage across all learners" }) => {
  const data = rows?.length ? rows : FALLBACK_ROWS

  return (
    <Card className="dark:bg-transparent">
      <CardHeader className="border-b pb-4">
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="p-0 py-1">
        <ShareBarList>
          {data?.map((row) => (
            <ShareBarListItem key={row?.label} value={row?.share}>
              <ShareBarListContent>
                <ShareBarListLabel>{row?.label}</ShareBarListLabel>
                <ShareBarListValue>{row?.share}%</ShareBarListValue>
              </ShareBarListContent>
              <ShareBarListFill />
            </ShareBarListItem>
          ))}
        </ShareBarList>
      </CardContent>
    </Card>
  )
}

export default LearnerMix